import { render, staticRenderFns } from "./InvoicesPaidModal.vue?vue&type=template&id=9af6dbc2&"
import script from "./InvoicesPaidModal.vue?vue&type=script&lang=js&"
export * from "./InvoicesPaidModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports